module.exports = __webpack_public_path__ + "static/img/set_otameshi.b7c3a54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/set_otameshi.png
// module id = vBGc
// module chunks = 1